import React from "react";

import { clientUrl } from "../../constants/site-urls";
import { createEvent } from "../../utils/create-event";

import TemplateSummary from "../template-summary";

const templates = [
  {
    name: "Popup starter",
    slug: "basic-popup",
    image_link: "templates/basic/popup-template.jpg",
    type: "Basic",
  },
  {
    name: "New tab starter",
    slug: "basic-new-tab",
    image_link: "templates/basic/new-tab-template.jpg",
    type: "Basic",
  },
  {
    name: "Context menu starter",
    slug: "basic-context-menu",
    image_link: "templates/basic/context-menu-template.jpg",
    type: "Basic",
  },
  {
    name: "Devtools starter",
    slug: "basic-devtools",
    image_link: "templates/basic/devtools-template.jpg",
    type: "Basic",
  },
  {
    name: "Popup full page starter",
    slug: "basic-popup-full-page",
    image_link: "templates/basic/popup-full-page-template.jpg",
    type: "Basic",
  },
  {
    name: "Messaging starter",
    slug: "basic-messaging",
    image_link: "templates/basic/messaging-template.jpg",
    type: "Basic",
  },
];

const BasicList = () => {
  return (
    <div className="relative">
      <ul
        role="list"
        className="grid grid-cols-1 gap-6 mt-6 sm:grid-cols-2 lg:grid-cols-3"
      >
        {templates.map((template) => (
          <TemplateSummary template={template} />
        ))}
      </ul>
      <div class="pointer-events-none absolute -inset-x-2.5 -bottom-2.5 h-[20%] bg-gradient-to-t from-white from-60% via-white via-90% sm:h-[40%]"></div>
      <div class="pointer-events-none relative z-10 -mt-5 flex justify-center">
        <a
          class="inline-flex justify-center rounded-lg text-sm font-semibold py-3 px-5 bg-emerald-500 text-white hover:bg-emerald-600 pointer-events-auto"
          href={`${clientUrl}/?ref=preview&type=basic`}
          onClick={() => {
            createEvent("View templates");
          }}
        >
          <span>View all basic templates</span>
        </a>
      </div>
    </div>
  );
};

export default BasicList;
